import { FC } from 'react';
import {
  StyledInquiryWrap,
  StyledLargeLabel,
  StyledNoteText,
  StyledStepContent
} from './Styled';
import Checkbox from '../chat/Checkbox';
import Image from 'next/image';
import lineButtonBubbleImage from '../../public/img_line_button_bubble.png';
import { StyledRedText } from '../tutorial/Styled';

const WalkthroughInquiry: FC<{
  value: boolean;
  onChange: (event: boolean) => void;
}> = ({ value, onChange }) => {
  return (
    <StyledStepContent>
      <StyledInquiryWrap>
        <div>
          <StyledLargeLabel normalText>
            <Checkbox
              value={value ? '1' : '0'}
              checked={value}
              onChange={(event) =>
                onChange((event.target as HTMLInputElement).checked)
              }
              size="lg"
            />
            物件詳細ページに「LINE問合せ」
            <br />
            「メッセージ問合せ」ボタンを表示します
          </StyledLargeLabel>
          <StyledNoteText>
            <p>※後から非表示にすることもできます</p>
            <p>
              ※「LINE問合せ」「メッセージ問合せ」ボタンは
              <br />
              <StyledRedText>PCサイトには表示されません。</StyledRedText>
            </p>
          </StyledNoteText>
        </div>
        <Image
          className="inquiry-explanation-image"
          alt=""
          src={lineButtonBubbleImage}
          width={633}
          height={245}
        />
      </StyledInquiryWrap>
    </StyledStepContent>
  );
};

export default WalkthroughInquiry;
